export const isSaveChangesModalOpen = (state) => {
  return state.isSaveChangesModalOpen
}
